import { AxiosRequestConfig } from "axios"

/** Axios request config extended for auth recovery retries. */
export type AuthAxiosRequestConfig = AxiosRequestConfig & {
    _retry?: boolean
    /** When set, the request interceptor must use this token and not replace it from cache. */
    _authRecoveryToken?: string
}

export const getAuthRecoveryToken = (config: AxiosRequestConfig): string | undefined =>
    (config as AuthAxiosRequestConfig)._authRecoveryToken
